export const RECAPTCHA_SITE_KEY ="6Lf19AgiAAAAAAHvJt6TnAwQ3lEPNA6WAlCSwhd6" //remote
export const USD_TO_KES_EX_RATE = 125;
export const KES_CURRENCY_SYMBOL= "Kshs.";
export const USD_CURRENCY_SYMBOL= "US$.";
